import { graphHooks } from '@tunasong/graph-lib/react'
import { Transform } from '@tunasong/icons'
import type { RenderMenuItemProps } from '@tunasong/plugin-lib'
import { useGlobalAppContext } from '@tunasong/plugin-lib'
import { isEntity, isPersisted } from '@tunasong/schemas'
import {useNavigateToEntity, ListItemIcon, ListItemText, MenuItem as MuiMenuItem} from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useCallback } from 'react'
import { setup } from './setup.js'

export const ConvertToBandspaceMenuItem: FC<RenderMenuItemProps> = props => {
  const { element, onClose, ...restProps } = props
  const navigateToEntity = useNavigateToEntity()
  const updateEntity = graphHooks.useEntityUpdate()
  const globalContext = useGlobalAppContext()
  const { entity: parent } = graphHooks.useEntity(isEntity(element) ? element.parentId : null)

  const disabled = false
  const handleConvert = useCallback(async () => {
    if (!(isPersisted(element) && isEntity(element))) {
      return
    }
    updateEntity(element.id, {
      type: 'bandspace',
    })
    await setup({
      entity: element,
      parent,
      globalContext,
    })
    navigateToEntity(element)
    if (onClose) {
      onClose()
    }
  }, [element, globalContext, navigateToEntity, onClose, parent, updateEntity])

  return (
    <MuiMenuItem {...restProps} disabled={disabled} onClick={handleConvert}>
      <ListItemIcon>
        <Transform />
      </ListItemIcon>
      <ListItemText>Convert to Band Space</ListItemText>
    </MuiMenuItem>
  )
}
